
import { faMoon, faSun } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Container, IconButton, IconButtonProps, lighten, styled, Toolbar, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { FC, useContext } from 'react';
import { Outlet } from 'react-router-dom';

import ThemeContext from '../../contexts/styles/ThemeContext';
import NavLogoButton from '../buttons/NavLogoButton';
import ProfileDropdown from '../buttons/ProfileDropdown';


interface IAdminLayoutProps { }

const StyledAppBar = styled(AppBar)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    background: lighten('#252423ff', 0.15)
}));


const StyledIconButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
    minHeight: '40px', 
    maxHeight: '40px', 
    maxWidth: '40px',
    minWidth: '40px', 
    backgroundColor: lighten("#252423ff", 0.3),
    margin: '0 6px',

    "&:hover": {
        backgroundColor: theme.palette.primary.main,
        boxShadow: '0 0px 3px 2px rgba(0,0,0,0.12), 0 0px 2px rgba(0,0,0,0.24)'
    },

    "&:active": {
        backgroundColor: theme.palette.secondary.main
    }
}));

const StyledToolbar = styled(Toolbar)(() => ({
    minHeight: '75px !important',
    maxHeight: '75px !important',
    width: '100vw',
    margin: '0 auto',

    "@media (min-width: 1300px)": {
        width: '1260px'
    }
}));

const AdminLayout: FC<IAdminLayoutProps> = () => {
    const theme = useTheme();
    const { theme: mode, toggleTheme } = useContext(ThemeContext);

    return (
        <Box 
            sx={{
                position: 'relative',
                width: '100vw',
                // height: '100vh',
                // overflowX: 'hidden',
                // overflowY: 'auto',
                backgroundColor: theme.palette.background.default//lighten(theme.palette.background.default, 0.1),
                //backgroundImage: `linear-gradient(25deg, ${theme.palette.background.default}, ${lighten(theme.palette.background.default, 0.1)})`
            }}
        >
            <CssBaseline />
            <StyledAppBar>
                <StyledToolbar>
                    <Box>
                        <NavLogoButton />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'flex-end'
                        }}
                    >
                        <StyledIconButton 
                            color="primary"
                            disableRipple 
                            onClick={() => toggleTheme()}
                        >
                            {
                                mode === 'light' ? 
                                    <FontAwesomeIcon color='white' fontSize='1.2rem' icon={faMoon} /> : 
                                    <FontAwesomeIcon color='white' fontSize='1.2rem' icon={faSun} />
                            }
                        </StyledIconButton>
                        <ProfileDropdown />
                    </Box>
                </StyledToolbar>
            </StyledAppBar>
            <Box 
                sx={{ height: 75 }}
            />
            <Container maxWidth="lg">
                {/* <AdminBreadcrumbs /> */}
                <Outlet/>
            </Container>
        </Box>
    );
}

export default AdminLayout;